// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PilotClozeDragBucketDisplay(props) {
  return React.createElement("div", {
              className: "flex flex-wrap items-center gap-4 mb-5 PilotClozeDragBucketDisplay"
            }, props.children);
}

var make = PilotClozeDragBucketDisplay;

var $$default = PilotClozeDragBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
